import { LifecycleListenerInterface } from '../../../../modules/src/lib/core/interfaces/lifecycle-listener.interface';
import { Injectable } from '@angular/core';
import { OrganizationManager } from '../managers/organization.manager';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';

@Injectable()
export class OrganizationLifecycleListener implements LifecycleListenerInterface {
  constructor(private readonly organizationManager: OrganizationManager, private readonly authService: AuthService) {
  }

  async onFirstLoad(): Promise<void> {
    this.authService.isAuthenticated$.pipe(take(1)).subscribe(isAuthenticated => {
      if (isAuthenticated === false) {
        return;
      }

      console.debug('Init organization manager.');
      this.organizationManager.init();
    });

  }

}
